interface ResizeHandlesProps {
    onResizeStart: (e: React.MouseEvent, x: number, y: number) => void;
}

export const ResizeHandles = ({ onResizeStart }: ResizeHandlesProps) => {
    return (
        <>
            <div className="absolute bottom-0 right-0 w-4 h-4 cursor-se-resize" onMouseDown={(e) => onResizeStart(e, 1, 1)} />
            <div className="absolute bottom-0 left-0 w-4 h-4 cursor-sw-resize" onMouseDown={(e) => onResizeStart(e, -1, 1)} />
            <div className="absolute top-0 right-0 w-4 h-4 cursor-ne-resize" onMouseDown={(e) => onResizeStart(e, 1, -1)} />
            <div className="absolute top-0 left-0 w-4 h-4 cursor-nw-resize" onMouseDown={(e) => onResizeStart(e, -1, -1)} />
            <div className="absolute top-0 w-full h-1 cursor-n-resize" onMouseDown={(e) => onResizeStart(e, 0, -1)} />
            <div className="absolute bottom-0 w-full h-1 cursor-s-resize" onMouseDown={(e) => onResizeStart(e, 0, 1)} />
            <div className="absolute left-0 h-full w-1 cursor-w-resize" onMouseDown={(e) => onResizeStart(e, -1, 0)} />
            <div className="absolute right-0 h-full w-1 cursor-e-resize" onMouseDown={(e) => onResizeStart(e, 1, 0)} />
        </>
    );
};
